export default class Form {
    constructor($form) {
        this.$form = $form;
        this.$captchaInput = this.$form.querySelector('[data-recaptcha]');
        this.$error = this.$form.querySelector('.form__group--error');
        this.useCaptcha = this.$captchaInput !== null;
        this.submitted = false;
        this.$formGroups = this.$form.querySelectorAll('[data-form-group]');

        this.onSubmit = this.onSubmit.bind(this);
        this.getCaptchaToken = this.getCaptchaToken.bind(this);
        this.setCaptchaToken = this.setCaptchaToken.bind(this);
        this.passwordControl = this.passwordControl.bind(this);

        this.$form.addEventListener('submit', this.onSubmit);

        // if we have an error
        if (this.$error) {
            window.scrollTo(0, (this.$error.getBoundingClientRect().top + window.scrollY) - document.querySelector('[data-header]').getBoundingClientRect().height);
        }

        this.$formGroups.forEach(($group) => {
            this.passwordControl($group);
        })
    }

    /**
     * On submit
     * we will show a loader and check if we need to add a captcha token
     * @param e
     */
    onSubmit(e) {
        e.preventDefault();
        document.querySelector('body').classList.add('loading');

        if (this.submitted) {
            return;
        }

        if ( ! this.useCaptcha) {
            this.submitted = true;
            this.$form.submit();
            return;
        }

        grecaptcha.ready(this.getCaptchaToken);
    }

    /**
     * Get the captcha token
     * @returns {Promise<void>}
     */
    async getCaptchaToken() {
        const token = await grecaptcha.execute(this.$captchaInput.dataset.key, {action: 'homepage'});
        this.setCaptchaToken(token);
    }

    /**
     * Set the captcha token
     * @param token
     */
    setCaptchaToken(token) {
        this.$captchaInput.value = token;
        this.submitted = true;

        this.$form.submit();
    }

    passwordControl($group) {
        if( ! $group.querySelector('[data-password-control]')) {
            return;
        }
        this.$control = $group.querySelector('[data-password-control]');
        this.$button = $group.querySelector('[data-toggle-password-visibility]');

        this.$button.addEventListener('click', (e) => {
            e.preventDefault();
            if(this.$control.type === 'password') {
                this.$control.type = 'text';
                return;
            }
            this.$control.type = 'password';
        })
    }
}
